"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var EvaluationMetadata_1 = require("./EvaluationMetadata");
var ConfigSpec_1 = require("./ConfigSpec");
var StatsigLocalStorage_1 = __importDefault(require("./utils/StatsigLocalStorage"));
var Constants_1 = require("./utils/Constants");
var StatsigStore = /** @class */ (function () {
    function StatsigStore(options) {
        this.options = options;
        this.lcut = 0;
        this.reason = EvaluationMetadata_1.EvaluationReason.Uninitialized;
        this.featureGates = {};
        this.dynamicConfigs = {};
        this.layerConfigs = {};
        this.loadFromLocalStorage();
    }
    StatsigStore.prototype.setInitializeValues = function (initializeValues, reason) {
        var updated = this.setConfigSpecs(initializeValues, reason);
        if (updated) {
            this.saveToLocalStorage(initializeValues);
        }
    };
    StatsigStore.prototype.saveToLocalStorage = function (initializeValues) {
        try {
            StatsigLocalStorage_1.default.setItem(Constants_1.INTERNAL_STORE_KEY, JSON.stringify(initializeValues));
        }
        catch (e) { }
    };
    StatsigStore.prototype.loadFromLocalStorage = function () {
        var cachedValues = StatsigLocalStorage_1.default.getItem(Constants_1.INTERNAL_STORE_KEY);
        if (cachedValues !== null) {
            try {
                var newValues = JSON.parse(cachedValues);
                this.setConfigSpecs(newValues, EvaluationMetadata_1.EvaluationReason.Cache);
            }
            catch (e) {
                StatsigLocalStorage_1.default.removeItem(Constants_1.INTERNAL_STORE_KEY);
                this.setEvaluationReason(EvaluationMetadata_1.EvaluationReason.CacheFailure);
            }
        }
    };
    StatsigStore.prototype.getLastUpdateTime = function () {
        return this.lcut;
    };
    StatsigStore.prototype.setEvaluationReason = function (evalReason) {
        this.reason = evalReason;
    };
    StatsigStore.prototype.setConfigSpecs = function (values, updatedReason) {
        var _a;
        var updatedGates = {};
        var updatedConfigs = {};
        var updatedLayers = {};
        var featureGates = values.feature_gates;
        var dynamicConfigs = values.dynamic_configs;
        var layerConfigs = values.layer_configs;
        if (!Array.isArray(featureGates) ||
            !Array.isArray(dynamicConfigs) ||
            !Array.isArray(layerConfigs)) {
            return false;
        }
        for (var _i = 0, featureGates_1 = featureGates; _i < featureGates_1.length; _i++) {
            var gateJSON = featureGates_1[_i];
            try {
                var gate = new ConfigSpec_1.ConfigSpec(gateJSON);
                updatedGates[gate.name] = gate;
            }
            catch (e) {
                return false;
            }
        }
        for (var _b = 0, dynamicConfigs_1 = dynamicConfigs; _b < dynamicConfigs_1.length; _b++) {
            var configJSON = dynamicConfigs_1[_b];
            try {
                var config = new ConfigSpec_1.ConfigSpec(configJSON);
                updatedConfigs[config.name] = config;
            }
            catch (e) {
                return false;
            }
        }
        for (var _c = 0, layerConfigs_1 = layerConfigs; _c < layerConfigs_1.length; _c++) {
            var layerJSON = layerConfigs_1[_c];
            try {
                var config = new ConfigSpec_1.ConfigSpec(layerJSON);
                updatedLayers[config.name] = config;
            }
            catch (e) {
                return false;
            }
        }
        this.featureGates = updatedGates;
        this.dynamicConfigs = updatedConfigs;
        this.layerConfigs = updatedLayers;
        this.lcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        this.reason = updatedReason;
        return true;
    };
    StatsigStore.prototype.getDynamicConfig = function (configName) {
        var _a;
        return (_a = this.dynamicConfigs[configName]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigStore.prototype.getFeatureGate = function (gateName) {
        var _a;
        return (_a = this.featureGates[gateName]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigStore.prototype.getLayerConfig = function (layerName) {
        var _a;
        return (_a = this.layerConfigs[layerName]) !== null && _a !== void 0 ? _a : null;
    };
    StatsigStore.prototype.getGlobalEvaluationDetails = function () {
        var _a, _b;
        return {
            reason: (_a = this.reason) !== null && _a !== void 0 ? _a : EvaluationMetadata_1.EvaluationReason.Uninitialized,
            time: (_b = this.lcut) !== null && _b !== void 0 ? _b : 0,
        };
    };
    return StatsigStore;
}());
exports.default = StatsigStore;
